export enum ActiveComponent {
  Product0,
  Product1,
  Product2,
  Product3,
  Home,
}
